export type CapacitorNativePlatform = 'ios' | 'android';

/**
 * Extract the native OS version without sending the full browser user agent as
 * device metadata. Some iPad WebViews use a desktop-style user agent; in that
 * case it is safer to omit the version than report the macOS compatibility
 * version as iPadOS.
 */
export function getNativeOsVersion(
  userAgent: string,
  platform: CapacitorNativePlatform,
) {
  const match =
    platform === 'android'
      ? /Android\s+([0-9]+(?:[._][0-9A-Za-z]+)*)/i.exec(userAgent)
      : /CPU(?: iPhone)? OS\s+([0-9_]+)/i.exec(userAgent);

  const version = match?.[1]?.replaceAll('_', '.');

  return version && version.length <= 64 ? version : undefined;
}
